export default ['assembly-mx'];
